import React from "react";
import { TFunction } from "next-i18next";
import SocialLinks from "../_shared/SocialLinks";
import styles from "../../styles/components/skills-hub/ShareAMemory.module.scss";

// Closes the page: an invitation to share a Skills Hub memory and tag us.
// Moved out of the closure notice so the notice can hand straight on to the
// SOLS edu card, the page's main call to action. The accounts to tag sit next
// to the ask; same links as the thank-you pages, at the smaller size.
const ShareAMemory = (props: Props) => {
  const { t } = props;

  return (
    <section className={styles.share}>
      <p>{t("closure-p2")}</p>
      <SocialLinks size="small" />
    </section>
  );
};

interface Props {
  t: TFunction;
}

export default ShareAMemory;
